module.exports = __webpack_public_path__ + "img/chord-down.a3a0c24f.png";